import { FeatureVisibility, IFeature } from '@principle-theorem/feature-flags';

export const AI_SCRIBE_FEATURE: IFeature = {
  label: 'ai-scribe',
  visibility: FeatureVisibility.OptIn,
  permissions: [],
};
